import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import './PhoneNumberInput.css';

const SUPPORTED_COUNTRY_CODES = ['GB', 'IE'];

const DEFAULT_COUNTRY = process.env.REACT_APP_DEFAULT_PHONE_COUNTRY || 'GB';

const PhoneNumberInput = ({
    number,
    onChange,
    onCountryChange,
    errorMessage,
    placeholder = 'Your phone number',
    label = 'Your mobile number'
}) => {
    return (
        <div
            className={`MobileInputWrapper ${
                errorMessage ? 'MobileInputWrapper--error' : ''
            }`}
        >
            <PhoneInput
                id="mobile-number"
                placeholder={placeholder}
                value={number}
                onChange={onChange}
                onCountryChange={onCountryChange}
                defaultCountry={DEFAULT_COUNTRY}
                countries={SUPPORTED_COUNTRY_CODES}
                addInternationalOption={false}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-for,jsx-a11y/label-has-associated-control */}
            <label
                htmlFor="mobile-number"
                className="MuiFormLabel-root MobileInputLabel"
            >
                {label}
            </label>
            {errorMessage && <p className="MobileInputError">{errorMessage}</p>}
        </div>
    );
};

export default PhoneNumberInput;
